<!--
 * @Author: Junjie
 * @Date: 2022-06-21 16:25:22
 * @LastEditTime: 2022-06-22 15:33:39
 * @email: 781433561@qq.com
 * @Description: 
-->
<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': true} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <dev-working-conditions-detail :disabled="true" ref="realForm"></dev-working-conditions-detail>
  </j-modal>
</template>

<script>

  import DevWorkingConditionsDetail from './DevWorkingConditionsDetail'
  export default {
    name: 'DevWorkingConditionsDetailModal',
    components: {
      DevWorkingConditionsDetail
    },
    data () {
      return {
        title: '设备运行详情',
        width: 1200,
        visible: false,
      }
    },
    methods: {
      show (devId) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.show(devId);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>